module.exports = __webpack_public_path__ + "img/position-view.37131721.svg";